import React, { Component } from 'react';
import { Printer, Download, Loader } from 'react-feather';
import download from 'downloadjs';
import moment from 'moment';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import ClickOutside from 'react-click-outside';
import { fetchDownload } from '../../cruds/remote';
import { classNames } from '../../functions/classNames';
import './DownloadButton.css';

export const DropdownDownloadContent = ({ onClick, children }) => (
  <a onClick={onClick}>{children}</a>
);

class DropdownDownloadButton extends Component {
  constructor(props) {
    super(props);
    this.state = { isDownloading: false, isHidden: true };
  }

  handleClick = () => {
    if (this.state.isDownloading) {
      return;
    }

    this.setState({ isHidden: !this.state.isHidden });
  };

  closeDropdown = () => {
    this.setState({ isHidden: true });
  };

  downloadFile = ({ filters, from, type, extension }) => {
    const now = moment().format('DDMMYYYY_HHmmss');
    const fileName = 'export_' + from + '_' + now + '.' + extension;
    const updatedFilters = { ...filters };
    updatedFilters.maxResults = 0;

    this.setState({ isDownloading: true, isHidden: true }, () =>
      fetchDownload(from + '/' + extension, updatedFilters)
        .then(res => {
          download(res, fileName, type);
          this.setState({ isDownloading: false });
        })
        .catch(err => this.setState({isDownloading: false},
                () => {this.props.handleError(err.message? err.message : err.statusText, null, false)}
              ))
        );

  };

  renderIcon = () => {
    if (this.state.isDownloading) {
      return <Loader size={18} />;
    }

    if (this.props.iconType === 'printer') {
      return <Printer size={18} />;
    }

    return <Download size={18} />;

  };

  renderChildren = () => {
    if (this.state.isHidden) {
      return;
    }

    const children = React.Children.map(this.props.children,
                        child => React.cloneElement(child, {
                          onClick: () => this.downloadFile(child.props),
                        }));

    return <div className="content">
              {children}
            </div>;
  };

  render() {
    const className = classNames('exportButton', (this.state.isDownloading ? 'loading' : ''));
    return (
      <span className="DownloadButton">
        <span className={classNames('tooltip', this.props.wide ? 'tooltip-wide' : '')}>
          {getLabel(this.context.locale, this.props.tooltip)}
        </span>
        <ClickOutside className={className}
              onClick={this.handleClick}
              onClickOutside={this.closeDropdown}
        >
          {this.renderIcon()}
          {this.renderChildren()}
        </ClickOutside>
      </span>

    );
  }

}

DropdownDownloadButton.contextTypes = {
  locale: PropTypes.string,
};

export default DropdownDownloadButton;



// WEBPACK FOOTER //
// ./src/main/components/output/DropdownDownloadButton.js